import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const vendorApi = createApi({
  reducerPath: "vendorApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Vendors"],
  endpoints: (builder) => ({
    getAllVendors: builder.query({
      query: (arg) => {
        let page = 1;
        let search = "";
        if (typeof arg === "number") page = arg;
        else if (arg && typeof arg === "object") {
          page = arg.page || 1;
          search = arg.search || "";
        }
        return {
          url: "/vendor",
          method: "GET",
          params: { page, ...(search && { search }) },
        };
      },
      providesTags: ["Vendors"],
    }),
    createVendor: builder.mutation({
      query: (body) => ({
        url: "/vendor",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Vendors"],
    }),
    updateVendor: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/vendor/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Vendors"],
    }),
  }),
});

export const {
  useGetAllVendorsQuery,
  useCreateVendorMutation,
  useUpdateVendorMutation,
} = vendorApi;
